import { ChangeEvent, useEffect,useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Chat from '../../components/app/chat/Chat';
import {faArrowLeftLong, faPlay} from '@fortawesome/free-solid-svg-icons'
import { extensionsRichTextEditor, MenuBarRichTextEditor } from '../../components/app/wordEditor/MenuBarTextEditor';
import { EditorContent, useEditor } from '@tiptap/react';
import { ChatMessage } from '../../types/backend/SengiLabsTypes';
import { useNavigateBack } from '../../hooks/useNavigationBack';

//TODO:send first hidden message with job definition in backend and get chatID 
export default function PromptChecker() {
    const { t } = useTranslation('toolsApps');
    const navigateBack = useNavigateBack();

    const [prompt, setPrompt] = useState('');
    const [acceptAGB, setAcceptAGB] = useState(false);
    const [acceptCosts, setAcceptCosts] = useState(false);
    const [analysisStart, setAnalysisStart] = useState(false);

    const editor = useEditor({
        extensions: extensionsRichTextEditor,
        content: prompt,
        onUpdate({ editor }) {
        setPrompt(editor.getHTML());
        },
    });

    const hancleCheckBoxAGB = (event:ChangeEvent<HTMLInputElement>) => {
        const value = event.target.checked;
        setAcceptAGB(value);
    };
    const hancleCheckBoxCosts = (event:ChangeEvent<HTMLInputElement>) => {
        const value = event.target.checked;
        setAcceptCosts(value);
    };

    const getChatMessages = (messages:ChatMessage[]) => {
        if(messages.length > 0 && messages[messages.length-1].role == 'assistant' && messages[messages.length-1].contents.length === 1){
            let lastMessage = messages[messages.length-1].contents[0].element;
            setPrompt(lastMessage);
            editor.commands.setContent(lastMessage);
        }
    };
    //USE EFFECTS
    useEffect(() => {
        document.title = t('promptChecker.documentTitle');
        let navbarTitle = document.getElementById('navbar_title');
        if(navbarTitle){
            navbarTitle.textContent = t('promptChecker.documentTitle');
        }
      },[]);

    if (!editor) {
        return (<></>);
    }
    return (
        <div className="container-fluid prompt-checker-page">
            <div className='d-flex flex-column h-100'>
                <div className='row mx-0'>
                    <div className='col-auto py-2 px-0'>
                        <button 
                            onClick={() => navigateBack()}
                            className="btn btn-outline-secondary btn-sm ms-3"
                            title={t('toolsApps:back')}
                        >
                        <FontAwesomeIcon
                                icon={faArrowLeftLong}
                                size="1x"
                                title={t('back')}
                            />
                        </button>
                    </div>
                </div>

                <div className="row flex-shrink-0">
                <div className="h1 p-2">
                    {t('promptChecker.heading')}
                </div>
                </div>
                { !analysisStart
                    ?   <>
                            <div className='row'>
                                <p>{t('promptChecker.intro')}</p>
                            </div>
                            <div className='row my-2'>
                                <div className="col-10 ms-5">
                                    <div className='form-check'>
                                        <input
                                        className="form-check-input"
                                        type='checkbox'
                                        name='acceptAGBs'
                                        id='acceptAGBs'
                                        checked={acceptAGB}
                                        onChange={event => hancleCheckBoxAGB(event)}
                                        />
                                        <label htmlFor='acceptAGBs' className='form-check-label'>
                                        {t('promptChecker.acceptTerms')}
                                        </label>
                                    </div>
                                    <div className='form-check'>
                                        <input
                                        className="form-check-input"
                                        type='checkbox'
                                        name='acceptCosts'
                                        id='acceptCosts'
                                        checked={acceptCosts}
                                        onChange={event => hancleCheckBoxCosts(event)}
                                        />
                                        <label htmlFor='acceptCosts' className='form-check-label'>
                                            {t('promptChecker.acceptCostsLabel')}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className={`row center mt-5 ${analysisStart? 'border-bottom pb-5' : ''}`}>
                                <div className='col'></div>
                                <div className='col'>
                                    <button
                                        className='btn btn-primary'
                                        title={t('promptChecker.startAnalysisTitle')}
                                        disabled={!acceptAGB || !acceptCosts}
                                        onClick={() => setAnalysisStart(true)}
                                    >
                                        <FontAwesomeIcon
                                            icon={faPlay}
                                            className='me-2 ms-0'
                                            size={'1x'}
                                        />
                                        {t('promptChecker.startAnalysisButton')}
                                    </button>
                                </div>
                                <div className='col'></div>
                            </div>
                        </>
                    :   <>
                            <div className="d-flex flex-row flex-grow-1 overflow-hidden min-h-0 mb-2">
                                <div className="col-6 border-end d-flex flex-column min-h-0 overflow-hidden pe-2">
                                    <MenuBarRichTextEditor editorIN={editor} />

                                    <div className="prompt-editor-shell scroll-y">
                                        <EditorContent
                                            className="prompt-editor-content"
                                            editor={editor}
                                        />
                                    </div>
                                </div>

                                <div className="col-6 d-flex flex-column min-h-0 overflow-hidden">
                                    <Chat
                                        chatID=''
                                        getChatMessages={getChatMessages}
                                    />
                                </div>
                            </div>
                        </>
                }
            </div>
        </div>
    );
}
